import React from "react";
import GoodsRegardingsGenericSkeleton from "./GoodsRegardingsGenericSkeleton";

function GoodsRegardingsDetailSkeleton() {
  return (
    <>
      <GoodsRegardingsGenericSkeleton />
    </>
  );
}

export default GoodsRegardingsDetailSkeleton;
